import {RENEWAL_TYPE, USER_TYPE} from "./config";
import dayjs from 'dayjs';

/**
 * 性别过滤器
 * @param str
 * @param type
 * @returns {string}
 */
export function sexFilter(str, type = 1) {
    if (!str) return '';
    let data = {};
    str = str.toLowerCase();
    if (type === 1) {
        data = {f: '女', m: '男'};
    }
    return data[str] || '';
}

/**
 *
 * @param str
 * @returns {*}
 */
export function renewalTypeFilter(str) {
    const type = RENEWAL_TYPE.find(r => r.id === str);
    if (type && type.name) return type.name;
    return "";
}

/**
 * 由身份证获得sex
 * @param str
 * @returns {string}
 */
export const getSexFromIdCardFilter = function (str) {
    if (!str) return '';
    if (str.length === 18) {
        const sex = str.substring(16, 17);
        return sex % 2 === 1 ? '男' : '女';
    } else {
        return ''
    }
}

/**
 * 由身份证获得age
 * @param str
 * @returns {*}
 */
export const getAgeFromIdCardFilter = function (str, next = '岁') {
    if (!str) return '';
    const y = new Date().getFullYear();
    if (str.length === 18) {
        return (y - str.substring(6, 10)) + next;
    } else {
        return "";
    }
}

/**
 * 隐藏部分字符串
 * @param str
 * @param start
 * @param end
 * @param length
 * @returns {string}
 */
export const hiddenStr = function (str, start, end, length) {
    if (!str) return '';
    return str.substring(0, start) + new Array(length).fill('*').join('') + str.substring(str.length - end);
}
/**
 * 排班日期过滤器
 * @param str
 * @returns {string}
 */
export const schdateFilter = (str) => {
    if (!str) return '';
    if (str.length === 10) return str;
    return str.substr(0, 4) + '-' + str.substr(4, 2) + '-' + str.substr(6);
};

/**
 * 上下午过滤器
 * @param str
 * @returns {string|*}
 */
export const ampmFilter = (str) => {
    if (!str) return '';
    return {'1': '上午', '2': '下午'}[str];
}

/**
 * 叁体视频类型[screen,video,sip]
 * @param str
 */
export const tee3VideoTypeFilter = (str) => {
    if (!str) return '';
    return {
        screen: '屏幕共享',
        video: '摄像头',
        sip: '高清设备',
        "local-video": '本机摄像头',
        "local-screen": '本机屏幕共享'
    }[str] || '暂无' + str;
};
/**
 *
 * @param str
 * @param format
 * @returns {string|*}
 */
export const timeFilter = (str, format) => {
    if (!str) return str;
    return dayjs(str).format(format);
}

/**
 * 用户类型
 * @param str
 * @returns {*}
 */
export const userTypeFilter = str => {
    if (!str) return;
    return USER_TYPE[str].name;
}
